import { Box } from '@dtx-company/design-system/src'
import { ExpandMore } from '@mui/icons-material'
import { MenuAnchor } from './menu-anchor'
import { MenuItemData, isMenuItemLink } from '../menu-item-data'
import { MenuListItem } from './styled'
import { Submenu } from './submenu'
import { forwardRef } from 'react'
import { media } from '@dtx-company/shared-components/src/theme/media-queries'
import { useMenuItem } from '../hooks/use-menu-item'
import styled from 'styled-components'

type MenuListItemProps = {
  menuItem: MenuItemData
}

const StyledText = styled(Box)`
  font-size: 14px;
  font-weight: 500;
  padding: 0 8px;
  ${media.largeDesktop} {
    padding: 0 16px;
  }
  display: flex;
  align-items: center;
`
const StyledExpandMore = styled(ExpandMore)`
  font-size: 24px;
  margin-left: 5px;
`
export const MenuItem = forwardRef<HTMLLIElement, MenuListItemProps>(
  ({ menuItem }, ref): JSX.Element => {
    const { onMenuClick, onMouseEnter, onKeyDown, hasPopup, isExpanded, className, role } =
      useMenuItem({ menuItem })

    return isMenuItemLink(menuItem) ? (
      <MenuListItem ref={ref} role={role} onClick={onMenuClick} onKeyDown={onKeyDown} tabIndex={0}>
        <MenuAnchor menuItem={menuItem}>
          <StyledText color="inherit">{menuItem.label}</StyledText>
        </MenuAnchor>
      </MenuListItem>
    ) : (
      <MenuListItem
        ref={ref}
        aria-haspopup={hasPopup}
        aria-expanded={isExpanded}
        className={className}
        role={role}
        onClick={onMenuClick}
        onKeyDown={onKeyDown}
        onMouseEnter={onMouseEnter}
      >
        <StyledText color="inherit" role="button" tabIndex={0}>
          {menuItem.label}
          <StyledExpandMore className="expand" />
        </StyledText>
        <Submenu menuItem={menuItem} />
      </MenuListItem>
    )
  }
)

MenuItem.displayName = 'MenuItem'
